'use strict'

var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
  if (k2 === undefined) k2 = k
  Object.defineProperty(o, k2, { enumerable: true, get: function () { return m[k] } })
}) : (function (o, m, k, k2) {
  if (k2 === undefined) k2 = k
  o[k2] = m[k]
}))
var __exportStar = (this && this.__exportStar) || function (m, exports) {
  for (var p in m) if (p !== 'default' && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p)
}
var __importDefault = (this && this.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { 'default': mod }
}
Object.defineProperty(exports, '__esModule', { value: true })
exports.TURBOSQUID_API_ADAPTER = exports.STUDIO_API_ADAPTER = void 0
var Uploader_1 = __importDefault(require('./Uploader'))
__exportStar(require('./Uploader'), exports)
__exportStar(require('./RefreshableCredentials'), exports)
var StudioApiAdaptor_1 = require('./StudioApiAdaptor')

Object.defineProperty(exports, 'STUDIO_API_ADAPTER', { enumerable: true, get: function () { return StudioApiAdaptor_1.STUDIO_API_ADAPTER } })
var TurbosquidArtistAdaptor_1 = require('./TurbosquidArtistAdaptor')

Object.defineProperty(exports, 'TURBOSQUID_API_ADAPTER', { enumerable: true, get: function () { return TurbosquidArtistAdaptor_1.TURBOSQUID_API_ADAPTER } })
exports.default = Uploader_1.default
//# sourceMappingURL=index.js.map
